module.exports = __webpack_public_path__ + "img/film-simple.0445ac77.svg";